import { render, staticRenderFns } from "./status-history.vue?vue&type=template&id=01d2e4c0&"
import script from "./status-history.vue?vue&type=script&lang=js&"
export * from "./status-history.vue?vue&type=script&lang=js&"
import style0 from "./status-history.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports